import React from 'react';
import autobind from 'autobind-decorator';

import {BaseTableColumn} from "../../Common/Tables/BaseTableColumn";
import {PermissionCheckerEnhance} from "../../Common/Enhancements";

import {StreamBankLink} from "../../Common/StreamBankLink";

@PermissionCheckerEnhance
export class OrganizationNameTableColumn extends BaseTableColumn {
    constructor() {
        super();
    }

    @autobind
    _render() {
        if(this.props?.rowData?.organizationId != null && this.props.HasPermission('create_organization')) {
            return <StreamBankLink
                className="sb-actionable-link"
                Href={"/organizations/" + this.props.rowData.organizationId}
            >
                {this.props.Value}
            </StreamBankLink>;
        } else {
            return <p>{this.props.Value}</p>;
        }
    }
}


